<template>
  <div class="poll-create">
    <!-- Hero -->
    <div class="poll-hero ">
      <div class="poll-hero-icon">
        <f7-icon f7="chart_bar_fill" size="20" color="#fff" />
      </div>
      <div class="poll-hero-text">
        <div class="poll-hero-title">
          {{ editing ? $t("feed.editPoll") : $t("poll.create") }}
        </div>
        <div class="poll-hero-sub">{{ $t("poll.createSubtitle") }}</div>
      </div>
      <div class="poll-count-chip">
        <span class="poll-count-num">{{ poll.questions.length }}</span>
        <span class="poll-count-label">{{ $t("poll.questions") }}</span>
      </div>
    </div>

    <!-- Progress -->
    <div class="poll-progress">
      <div
        class="poll-progress-fill"
        :style="{ width: progressPct + '%' }"
      ></div>
    </div>

    <!-- Details -->
    <div class="poll-section  ">
      <div class="poll-section-heading margin-right-half">
        <f7-icon class="poll-section-icon" f7="doc_text" size="14" />
        <span>{{ $t("poll.details") }}</span>
      </div>
      <div class="poll-section-body poll-section-body--details card card-raised no-margin no-padding">
        <f7-list no-hairlines-md>
          <f7-list-input
            :label="$t('poll.title')"
            type="text"
            name="title"
            :placeholder="$t('poll.titlePlaceholder')"
            v-model="poll.title"
            required
          />
          <div class="poll-options-label">{{ $t("common.description") }}</div>
          <f7-text-editor
            class="poll-text-editor"
            :placeholder="$t('common.description')"
            :value="poll.description"
            @texteditor:change="(v) => (poll.description = v)"
            resizable
            required
            validate
            name="description"
            type="texteditor"
            :mode="'toolbar'"
          ></f7-text-editor>
          <f7-list-input
            :label="$t('common.endDate')"
            type="datetime-local"
            name="endDate"
            :min="minEndDate()"
            :placeholder="$t('common.endDate')"
            v-model="poll.endDate"
            required
          />
        </f7-list>
      </div>
    </div>

    <!-- Visibility & responses -->
    <div class="poll-section">
      <div class="poll-section-heading">
        <f7-icon class="poll-section-icon" f7="info_circle" size="14" />
        <span>{{ $t("poll.visibility") }}</span>
      </div>
      <div class="poll-section-body poll-section-body--details card card-raised no-margin no-padding">
        <f7-list no-hairlines-md>
          <f7-list-item>
            <div class="poll-toggle-row">
              <div class="poll-toggle-title">
                {{ $t("poll.isResponseVisible") }}
              </div>
              <f7-toggle
                v-model="poll.isResponseVisible"
                :style="{
                  '--f7-toggle-active-bg-color': 'var(--avocash-green)',
                }"
              />
            </div>
          </f7-list-item>
        </f7-list>
        <div class="poll-options-label">
          {{ $t("poll.afterPollResponseText") }}
        </div>
        <f7-text-editor
          class="poll-text-editor poll-text-editor--small"
          :placeholder="$t('poll.afterPollResponseText')"
          :value="poll.afterPollResponseText"
          @texteditor:change="(v) => (poll.afterPollResponseText = v)"
          resizable
          name="afterPollResponseText"
          type="texteditor"
          :mode="'toolbar'"
        ></f7-text-editor>
      </div>
    </div>

    <!-- Attachments -->
    <div class="poll-section">
      <div class="poll-section-heading">
        <f7-icon class="poll-section-icon" f7="photo_badge_plus" size="14" />
        <span class="padding-left-half">{{ $t("poll.attachments") }}</span>
      </div>
      <div class="poll-section-body">
        <AttachmentPicker />
      </div>
    </div>

    <!-- Questions -->
    <div class="poll-section">
      <div class="poll-section-heading">
        <f7-icon class="poll-section-icon" f7="list_bullet" size="14" />
        <span>{{ $t("poll.questions") }}</span>
      </div>
      <div class="poll-section-body poll-section-body--questions">
        <div
          v-for="(question, index) in poll.questions"
          :key="index"
          class="poll-question-item"
        >
          <f7-card :outline="true" class="poll-question-card no-padding no-margin-horizontal" :padding="false">
            <f7-card-header class="poll-question-header">
              <div class="poll-question-title">
                <span class="poll-question-num">{{ index + 1 }}</span>
                <!-- <f7-chip media-color="primary" :class="'poll-type-' + question.type"  class="poll-type-badge" :text="$t(questionTypeMeta(question.type).label)" >
        <template #media>
          <f7-icon
                    :f7="questionTypeMeta(question.type).icon" icon-color="primary"
                    size="11"
                  />
        </template>
      </f7-chip> -->
                <div
                  class="poll-type-badge chip"
                  :class="'poll-type-' + question.type"
                >
                  <div class="chip-media">
                    <f7-icon
                      color="primary"
                      :f7="questionTypeMeta(question.type).icon"
                    />
                  </div>
                  <div class="chip-label">
                    {{ questionTypeMeta(question.type).labe}}
                  </div>
                </div>
              </div>
              <f7-link
                @click="removeQuestion(index)"
                icon-ios="f7:trash"
                icon-md="material:delete"
                icon-size="18"
                :tooltip="$t('poll.removeQuestion')"
                class="poll-danger"
              />
            </f7-card-header>
            <f7-card-content>
              <f7-list no-hairlines-md>
                <f7-list-input
                  :label="$t('poll.questionText')"
                  type="text"
                  :placeholder="$t('poll.questionText')"
                  v-model="question.questionText"
                  required
                />

                <f7-list-item
                  :title="$t('poll.questionType')"
                  smart-select
                  :smart-select-params="{
                    openIn: isTablet ? 'popover' : 'sheet',
                    closeOnSelect: true,
                    swipeToClose: true,
                  }"
                >
                  <select name="questionType" v-model="question.type">
                    <optgroup>
                      <option value="radio">
                        {{ $t("poll.singleChoice") }}
                      </option>
                      <option value="checkbox">
                        {{ $t("poll.multipleChoice") }}
                      </option>
                      <option value="select">
                        {{ $t("poll.dropDown") }}
                      </option>
                    </optgroup>
                    <optgroup>
                      <option value="text">
                        {{ $t("poll.short_text") }}
                      </option>
                      <option value="textarea">
                        {{ $t("poll.long_text") }}
                      </option>
                      <option value="email">
                        {{ $t("common.email") }}
                      </option>
                      <option value="tel">
                        {{ $t("common.phoneNumber") }}
                      </option>
                      <option value="number">
                        {{ $t("common.number") }}
                      </option>
                      <option value="url">
                        {{ $t("common.url") }}
                      </option>
                      <option value="date">
                        {{ $t("common.date") }}
                      </option>
                      <option value="datetime-local">
                        {{ $t("common.date_time") }}
                      </option>
                    </optgroup>
                    <optgroup>
                      <option value="rating">
                        {{ $t("poll.rating") }}
                      </option>
                      <option value="range">
                        {{ $t("common.range") }}
                      </option>
                    </optgroup>
                  </select>
                </f7-list-item>

                <f7-list-group>
                  <div v-if="isChoiceType(question.type)">
                    <div class="poll-options-label">
                      {{ $t("poll.options") }}
                    </div>
                    <div
                      v-for="(option, optIndex) in question.options"
                      :key="optIndex"
                      class="poll-option-row"
                    >
                      <f7-list-input
                        type="text"
                        :placeholder="$t('poll.option')"
                        v-model="option.optionText"
                        class="poll-option-input"
                      >
                        <template #content-end>
                          <f7-link
                            v-if="optIndex > 0"
                            @click="removeOption(question, optIndex)"
                            icon-ios="f7:minus_circle"
                            icon-md="material:remove_circle"
                            icon-size="20"
                            :tooltip="$t('poll.removeOption')"
                            class="poll-option-btn poll-danger"
                          />
                          <f7-link
                            v-if="optIndex === question.options.length - 1"
                            @click="addOption(question)"
                            :tooltip="$t('poll.addOption')"
                            icon-ios="f7:plus_circle"
                            icon-md="material:add_circle"
                            icon-size="20"
                            class="poll-option-btn poll-add"
                          >
                          </f7-link>
                        </template>
                      </f7-list-input>
                    </div>
                  </div>

                  <div v-if="isRangeType(question.type)">
                    <div class="poll-options-label">
                      {{ $t("poll.options") }}
                    </div>
                    <div class="grid cols-3">
                      <f7-list-input
                        :type="
                          question.type === 'range' ? 'number' : question.type
                        "
                        :label="$t('poll.min')"
                        :placeholder="$t('poll.optionPlaceholder')"
                        v-model="question.min"
                      />

                      <f7-list-input
                        :type="
                          question.type === 'range' ? 'number' : question.type
                        "
                        :label="$t('poll.max')"
                        :placeholder="$t('poll.optionMaxPlaceholder')"
                        v-model="question.max"
                      />

                      <f7-list-input
                        v-if="question.type === 'range'"
                        type="number"
                        min="1"
                        :label="$t('poll.step')"
                        :placeholder="$t('poll.optionStepPlaceholder')"
                        v-model="question.step"
                      />
                    </div>
                  </div>

                  <f7-list-item>
                    <div class="poll-toggle-row">
                      <div class="poll-toggle-title">
                        {{ $t("poll.required") }}
                      </div>
                      <f7-toggle
                        v-model="question.required"
                        :style="{
                          '--f7-toggle-active-bg-color': 'var(--avocash-green)',
                        }"
                      />
                    </div>
                  </f7-list-item>
                </f7-list-group>
              </f7-list>
            </f7-card-content>
          </f7-card>
        </div>

        <div class="poll-add-question">
          <f7-button
            @click="addQuestion"
            ripple
            outline
            round
            large
            color="auto"
            icon-ios="f7:plus_circle"
            icon-md="material:add_circle"
            class="poll-add-question-btn"
          >
            {{ $t("poll.addQuestion") }}
          </f7-button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="poll-footer">
      <f7-button
        @click="createPoll"
        :disabled="!isValid || creating"F
        ripple
        round-ios
        raised
        fill
        large
        class="poll-submit"
      >
        <span v-if="!creating">{{
          editing ? $t("feed.updatePoll") : $t("poll.create")
        }}</span>
        <f7-preloader v-else :size="20" color="white" />
      </f7-button>
      <div v-if="!isValid && !creating" class="poll-hint">
        <f7-icon f7="info_circle" size="13" />
        {{ validationHint }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { f7 } from "framework7-vue";
import { ref, computed, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { closeAdaptiveModal } from "../js/composables/useAdaptiveModal.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { usePollStore } from "../js/pinia-stores/poll.js";
import AttachmentPicker from "./feed/AttachmentPicker.vue";
import { seedDocumentsFromMedia } from "../js/feedManageUtils.js";
import i18n from "@/js/i18n.js";
import dayjs from "dayjs";
const t = i18n.global.t;
const props = defineProps({
  opened: {
    type: Boolean,
    default: false,
  },
  currentEntity: { type: Object, default: null },
  editing: { type: Boolean, default: false },
  pollToEdit: { type: Object, default: null },
});

const emit = defineEmits(["poll-created", "poll-updated", "closed"]);

const authStore = useAuthStore();
const pollStore = usePollStore();

const { profile, documentsUrl } = storeToRefs(authStore);
const isTablet = useTabletScreen().matches;

const CHOICE_TYPES = ["radio", "checkbox", "select"];
const RANGE_TYPES = ["range", "date", "datetime-local"];

const QUESTION_TYPE_META = {
  radio: { label: t("poll.singleChoice"), icon: "checkmark_seal_fill" },
  checkbox: { label: t("poll.multipleChoice"), icon: "checkmark_seal_fill" },
  select: { label: t("poll.dropDown"), icon: "checkmark_seal_fill" },
  text: { label: t("poll.short_text"), icon: "doc_text" },
  textarea: { label: t("poll.long_text"), icon: "doc_text" },
  email: { label: t("common.email"), icon: "doc_text" },
  tel: { label: t("common.phoneNumber"), icon: "doc_text" },
  number: { label: t("common.number"), icon: "doc_text" },
  url: { label: t("common.url"), icon: "doc_text" },
  date: { label: t("common.date"), icon: "calendar" },
  "datetime-local": { label: t("common.date_time"), icon: "calendar" },
  rating: { label: t("poll.rating"), icon: "star" },
  range: { label: t("common.range"), icon: "chart_bar_fill" },
};

function questionTypeMeta(type) {
  return (
    QUESTION_TYPE_META[type] || { label: t("poll.short_text"), icon: "doc_text" }
  );
}

function isChoiceType(type) {
  return CHOICE_TYPES.includes(type);
}

function isRangeType(type) {
  return RANGE_TYPES.includes(type);
}

function createDefaultPoll() {
  return {
    title: "",
    description: "",
    endDate: "",
    afterPollResponseText: "",
    groupId: props.currentEntity ? props.currentEntity.id : null,
    isResponseVisible: false,
    pollDocument: null,
    responses: [],
    questions: [],
    creator: {
      userId: useKeycloakStore().subject,
      name: profile.value ? profile.value.name : "Unknown",
    },
  };
}

function starterQuestion() {
  return {
    questionText: "",
    type: "radio",
    min: null,
    max: null,
    step: null,
    options: [
      { optionText: "", optionIndex: 1 },
      { optionText: "", optionIndex: 2 },
    ],
    required: false,
  };
}

const poll = ref(createDefaultPoll());
const shortId = ref(f7.utils.id());
const creating = ref(false);

function resetPoll() {
  poll.value = createDefaultPoll();
  if (props.currentEntity?.name) {
    poll.value.title = props.currentEntity.name;
  }
  poll.value.questions.push(starterQuestion());
  shortId.value = f7.utils.id();
  creating.value = false;
}

function prefillPoll(item) {
  const p = item?.poll || item || {};
  const hasQuestions = Array.isArray(p.questions) && p.questions.length > 0;
  poll.value = {
    title: p.title || p.headline || "",
    description: p.description || p.text || "",
    endDate: p.endDate || "",
    afterPollResponseText: p.afterPollResponseText || "",
    groupId: p.groupId || (props.currentEntity ? props.currentEntity.id : null),
    isResponseVisible: !!p.isResponseVisible,
    pollDocument: p.pollDocument || null,
    responses: p.responses || [],
    questions: hasQuestions
      ? p.questions.map((q) => ({
          questionText: q.questionText || "",
          type: q.type || "radio",
          min: q.min ?? null,
          max: q.max ?? null,
          step: q.step ?? null,
          options: Array.isArray(q.options)
            ? q.options.map((o, i) => ({
                optionText: o.optionText || o.label || "",
                optionIndex: i + 1,
              }))
            : [
                { optionText: "", optionIndex: 1 },
                { optionText: "", optionIndex: 2 },
              ],
          required: !!q.required,
        }))
      : [
          {
            questionText: p.title || "",
            type: "radio",
            min: null,
            max: null,
            step: null,
            options: Array.isArray(p.options)
              ? p.options.map((o, i) => ({
                  optionText: o.label || o.optionText || "",
                  optionIndex: i + 1,
                }))
              : [
                  { optionText: "", optionIndex: 1 },
                  { optionText: "", optionIndex: 2 },
                ],
            required: false,
          },
        ],
    creator: p.creator || {
      userId: useKeycloakStore().subject,
      name: profile.value ? profile.value.name : "Unknown",
    },
  };
  shortId.value = f7.utils.id();
  creating.value = false;
  authStore.clearDocumentsUrl();
  let media = item?.media || [];
  if (media.length === 0 && Array.isArray(p.attachments)) {
    media = p.attachments.map((a) => a.url || a).filter(Boolean);
  }
  if (media.length === 0 && p.pollDocument) media = [p.pollDocument];
  authStore.documentsUrl = seedDocumentsFromMedia(media);
}

watch(
  () => props.opened,
  (value) => {
    if (!value) return;
    if (props.editing && props.pollToEdit) {
      prefillPoll(props.pollToEdit);
    } else {
      resetPoll();
    }
  },
);

function minEndDate() {
  return dayjs().format("YYYY-MM-DDTHH:mm");
}

const isValid = computed(() => {
  const p = poll.value;
  if (!p.title.trim() || !p.endDate.trim()) return false;
  if (p.questions.length === 0) return false;
  return p.questions.every((q) => {
    if (!q.questionText.trim()) return false;
    if (isChoiceType(q.type)) {
      return (
        q.options.length > 0 && q.options.every((o) => o.optionText.trim())
      );
    }
    if (q.type === "range") {
      return (
        q.min != null &&
        q.max != null &&
        q.step != null &&
        Number(q.min) < Number(q.max) &&
        Number(q.step) > 0
      );
    }
    return true;
  });
});

const validationHint = computed(() => {
  const p = poll.value;
  const questionsMissing =
    p.questions.length === 0 || p.questions.some((q) => !q.questionText.trim());
  const optionsMissing = p.questions.some(
    (q) =>
      isChoiceType(q.type) &&
      (q.options.length === 0 || q.options.some((o) => !o.optionText.trim())),
  );
  const rangeMissing = p.questions.some(
    (q) =>
      q.type === "range" &&
      (q.min == null ||
        q.max == null ||
        q.step == null ||
        Number(q.min) >= Number(q.max) ||
        Number(q.step) <= 0),
  );
  if (questionsMissing || optionsMissing || rangeMissing) {
    return t("poll.addAtLeastOneQuestion");
  }
  return t("poll.fillRequiredFields");
});

const progressPct = computed(() => {
  const p = poll.value;
  let done = 0;
  if (p.title.trim()) done++;
  if (p.endDate.trim()) done++;
  if (p.questions.length > 0) done++;
  const allQuestionsValid = p.questions.every((q) => {
    if (!q.questionText.trim()) return false;
    if (isChoiceType(q.type)) {
      return q.options.every((o) => o.optionText.trim());
    }
    return true;
  });
  if (p.questions.length > 0 && allQuestionsValid) done++;
  return Math.round((done / 4) * 100);
});

function addQuestion() {
  poll.value.questions.push(starterQuestion());
}

function removeQuestion(index) {
  poll.value.questions.splice(index, 1);
}

function addOption(question) {
  question.options.push({
    optionText: "",
    optionIndex: question.options.length + 1,
  });
}

function removeOption(question, index) {
  if (question.options.length > 1) {
    question.options.splice(index, 1);
  }
}

async function createPoll() {
  if (!isValid.value || creating.value) return;
  creating.value = true;

  try {
    if (documentsUrl.value && documentsUrl.value.length > 0) {
      const docs = [...documentsUrl.value];
      const fresh = docs.filter((d) => d.file);
      if (fresh.length > 0) {
        authStore.documentsUrl = fresh;
        await authStore.postR2Document({
          shortId: shortId.value,
          bucketName: import.meta.env.VITE_R2_PUBLIC_BUCKET_NAME,
        });
      }
      const finalDocs = [
        ...docs.filter((d) => !d.file),
        ...authStore.documentsUrl,
      ];
      poll.value.pollDocument = finalDocs[0] ? finalDocs[0].url : null;
    }
    poll.value.creator = {
      userId: useKeycloakStore().subject,
      name: profile.value ? profile.value.name : "Unknown",
    };

    if (props.editing && props.pollToEdit) {
      const pollId = props.pollToEdit.poll?.id || props.pollToEdit.id;
      const updatedPoll = await pollStore.updatePoll({
        pollId,
        pollData: poll.value,
      });
      closeAdaptiveModal(".createNewPoll");
      closeAdaptiveModal(".createNewPostPopup");
      resetPoll();
      authStore.clearDocumentsUrl();
      f7.toast.show({
        text: i18n.global.t("feed.pollUpdated"),
        position: "center",
      });
      emit(
        "poll-updated",
        updatedPoll || {
          ...poll.value,
          id: pollId,
          pollDocument: poll.value.pollDocument,
        },
      );
      return;
    }

    const createdPoll = await pollStore.createPoll(poll.value);
    closeAdaptiveModal(".createNewPoll");
    closeAdaptiveModal(".createNewPostPopup");
    resetPoll();
    authStore.clearDocumentsUrl();
    f7.toast.show({
      text: i18n.global.t("poll.pollCreated"),
      position: "center",
    });
    emit("poll-created", createdPoll);
  } catch (error) {
    console.error("Error saving poll:", error);
    f7.toast.show({
      text: i18n.global.t("common.error"),
      position: "center",
    });
  } finally {
    creating.value = false;
  }
}

function onClosed() {
  resetPoll();
  emit("closed");
}

onMounted(() => {
  resetPoll();
});
</script>

<style scoped>
.poll-create {
  padding: 0 4px 16px;
}

/* Hero */
.poll-hero {
  display: flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, var(--avocash-green-light), #ffffff);
  border: 1px solid rgba(26, 107, 66, 0.14);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 14px;
}
.poll-hero-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  color: var(--avocash-green);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.poll-hero-text {
  flex: 1;
  min-width: 0;
}
.poll-hero-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--avocash-pit);
  line-height: 1.2;
}
.poll-hero-sub {
  font-size: 13px;
  color: #5f6b66;
  margin-top: 2px;
}
.poll-count-chip {
  flex-shrink: 0;
  background: var(--f7-card-bg-color, #fff);
  border: 1px solid rgba(26, 107, 66, 0.22);
  border-radius: 12px;
  padding: 8px 10px;
  text-align: center;
  min-width: 58px;
}
.poll-count-num {
  display: block;
  font-size: 18px;
  font-weight: 800;
  color: var(--avocash-green);
  line-height: 1;
}
.poll-count-label {
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #5f6b66;
  margin-top: 3px;
}

/* Progress */
.poll-progress {
  height: 6px;
  border-radius: 999px;
  background: var(--avocash-green-light);
  overflow: hidden;
  margin: 0 4px 14px;
}
.poll-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--avocash-green), var(--avocash-leaf));
  transition: width 0.3s ease;
}

/* Sections */
.poll-section {
  margin-bottom: 14px;
}
.poll-section-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: var(--avocash-green);
  margin: 0 4px 8px;
}
.poll-section-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--avocash-green-light);
  color: var(--avocash-green);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.poll-section-body {
  /* background: var(--f7-card-bg-color, #fff); */
  /* border: 1px solid rgba(28, 28, 30, 0.08); */
  border-radius: 14px;
  /* padding: 4px 12px; */
}
.poll-section-body--details {
  /* background: var(--f7-card-bg-color, #fff); */
  border: 1px solid rgba(28, 28, 30, 0.08);
  border-radius: 14px;
}

/* Text editors */
.poll-text-editor {
  --f7-text-editor-height: 170px;
}
.poll-text-editor--small {
  --f7-text-editor-height: 120px;
}

/* Toggle rows */
.poll-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 6px 0;
}
.poll-toggle-title {
  font-size: 15px;
  color: var(--avocash-pit);
}

/* Labels inside sections */
.poll-options-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #5f6b66;
  margin: 8px 0 2px 16px;
}

/* Question cards */
.poll-question-item {
  margin-bottom: 12px;
}
.poll-question-card {
  border-radius: 14px;
  overflow: hidden;
}
.poll-question-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: var(--avocash-surface);
}
.poll-question-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.poll-question-num {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: var(--avocash-green);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.poll-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--avocash-green);
  background: var(--avocash-green-light);
  white-space: nowrap;
}
.poll-type-date,
.poll-type-datetime-local {
  color: var(--avocash-blue);
  background: var(--avocash-blue-light);
}
.poll-type-rating {
  color: #8a6d1f;
  background: var(--avocash-gold-light);
}
.poll-type-range {
  color: var(--avocash-purple);
  background: var(--avocash-purple-light);
}

/* Danger / add affordances */
.poll-danger {
  color: var(--avocash-terracotta);
}
.poll-add {
  color: var(--avocash-green);
}

/* Option rows */
.poll-option-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.poll-option-input {
  flex: 1;
  min-width: 0;
}
.poll-option-btn {
  flex-shrink: 0;
}

/* Add question */
.poll-add-question {
  display: flex;
  justify-content: center;
  padding: 4px 0 8px;
}
.poll-add-question-btn {
  --f7-button-border-color: var(--avocash-green);
  --f7-button-text-color: var(--avocash-green);
  width: max-content;
  /* border: 2px solid var(--avocash-green); */
  /* border-radius: 25px; */
}

/* Footer */
.poll-footer {
  padding: 8px 4px 20px;
}
.poll-submit {
  --f7-button-fill-bg-color: var(--avocash-green);
  --f7-button-fill-text-color: #fff;
  width: 100%;
}
.poll-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 12px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
</style>
